import React from 'react';

import IMG_DARK_MODE from 'assets/images/online-booking/dark-mode.svg';
import IMG_LIGHT_MODE from 'assets/images/online-booking/neutralt-mode.svg';
import IMG_BRIGHT_MODE from 'assets/images/online-booking/slick-mode.svg';
import ImageOptionsInput from 'components/form/ImageOptionsInput.component';
import THEME_MODE_NCOB from 'constants/themeModeNcob.const';
import { useTranslation } from 'providers/GILT.provider';
import C from 'utils/values/constant.util';

const OPTIONS = C([
  {
    id: THEME_MODE_NCOB.neutral,
    descriptionTranslateKey: 'onlineBooking.brandingPanel.themes.neutral',
    src: IMG_LIGHT_MODE,
  },
  {
    id: THEME_MODE_NCOB.slick,
    descriptionTranslateKey: 'onlineBooking.brandingPanel.themes.slick',
    src: IMG_BRIGHT_MODE,
  },
  {
    id: THEME_MODE_NCOB.dark,
    descriptionTranslateKey: 'onlineBooking.brandingPanel.themes.dark',
    src: IMG_DARK_MODE,
  },
]);

const WidgetColorMode = (props) => {
  const { t } = useTranslation();

  const translatedOptions = OPTIONS.map((option) => ({
    ...option,
    description: t(option.descriptionTranslateKey),
  }));

  return <ImageOptionsInput {...props} options={translatedOptions} columns="three" />;
};

export default WidgetColorMode;
